<template>
  <div class="outer" id="home">
    <div class="main" :style="{'transform':'scale('+scaleX+')'}">
      <img v-default-img src="./home2.jpg" alt @click="foo($event)" />
      <span class="left top" :style="{top:'9px',left:'20px'}" @click="$router.push({path:'/dataAnalysis/reportForms/deviceStatistics'})"></span>
      <span class="left middle" :style="{top:'291px',left:'20px'}" @click="$router.push({path:'/dataAnalysis/reportForms/alarmStatistics'})"></span>
      <span class="left bottom" :style="{top:'580px',left:'20px'}" @click="$router.push({path:'/dataAnalysis/reportForms/YHstatistics'})"></span>
      <span class="down" :style="{top:'577px',left:'463px'}" @click="$router.push({path:'/dataAnalysis/reportForms/alarmStatistics'})"></span>
      <span class="downRight" :style="{top:'577px',left:'1293px'}" @click="$router.push({path:'management/allManagement/alarm/alarmSystem/alarm/relaAlarm'})"></span>
      <span class="right bottom" :style="{right:'20px',top:'577px'}" @click="$router.push({path:'/dataAnalysis/reportForms/XJstatistics'})"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scaleX: 1
    };
  },
  methods: {
    foo(e) {
      //console.log(e);
    }
  },
  mounted() {
    let o = document.getElementById("home");
    o.parentElement.style.padding = 0;
    this.scaleX = window.innerWidth / 1920;
    this.scaleY = window.innerHeight / 936;
    window.onresize = () => {
      this.scaleX = window.innerWidth / 1920;
      this.scaleY = window.innerHeight / 936;
    };
  }
};
</script>

<style scoped>
.outer {
  height: 100%;
}
.outer .main {
  width: 1920px;
  height: calc(936px - 64px);
  transform-origin: top left;
  padding-top: 0 !important;
}
.outer .main img {
  width: 100%;
  height: 100%;
  position: relative;
}
.outer .main .left {
  display: block;
  position: absolute;
  width: 430px;
  height: 270px;
}
.outer .main .down {
  display: block;
  position: absolute;
  width: 830px;
  height: 270px;
}
.outer .main .downRight{
  display: block;
  position: absolute;
  width: 163px;
  height: 270px;
}

.outer .main .right{
  display: block;
  position:absolute;
   height: 270px;
   width: 431px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/home/testpage/testHome2.vue